import Cache from '../utils/cache';

export default {
  provide() {
    return {
      Cache
    };
  },
  methods: {
    recovery() {
      this.$nextTick(() => {
        const comp = this.$refs.page;
        try {
          /** @type {{add: (k:string,v:any)=>void, remove: (k) => void, get: (k:string) => Object}} */
          const v = Cache.get(comp.$options.name);
          if (v) Object.assign(comp, v);
        } catch (e) {
          console.log(e);
        }
      });
    },
    cache() {
      this.$nextTick(() => {
        const comp = this.$refs.page;
        try {
          Cache.add(comp.$options.name, JSON.parse(JSON.stringify((comp || {}).$data || {})));
        } catch (e) {
          console.log(e);
        }
      });
    },
    clear() {
      Cache.clear();
    }
  }
};
